import "../Style/Skeleton.css"
import ToggleArrow from "./ToggleArrow";

const LoadingSpinner = () => {

    return (
        <div className="loading-spinner">
            <div className="spinner"></div>
        </div>
    );
}

const FakeDataRow = () => {

    return (
        <div className="fake-data-row">
            <div className="fake-first-data-row">
                <ToggleArrow isNeed={false} />
                {
                    [...Array(15)].map((e, i) => <div key={i} className="fake-data-cell"></div>)
                }
            </div>
        </div>
    );
}

const Skeleton = () => {

    return (
        <div className="skeleton">
            <LoadingSpinner></LoadingSpinner>
            {
                [...Array(6)].map((e, i) => <FakeDataRow key={i}></FakeDataRow>)
            }
        </div>
    );
}


export default Skeleton;